/**
 * Pagination threshold helpers for `react-data-table-component`.
 *
 * Most screens should use `DataTableWithAutoPagination` (imports this module internally).
 * You can import these helpers only for edge cases or non-JSX usage.
 *
 * `CommonDataTable.jsx` still imports the raw library directly and is unchanged.
 */
export const DATA_TABLE_PAGINATION_THRESHOLD = 100;

export function shouldShowDataTablePagination(recordCount) {
    const n = typeof recordCount === 'number' ? recordCount : Number(recordCount);
    if (!Number.isFinite(n) || n < 0) return false;
    return n > DATA_TABLE_PAGINATION_THRESHOLD;
}

/** Client-side table filtered into memory — uses array length. */
export function clientFilterDataTablePagination(filterListData) {
    const len = Array.isArray(filterListData) ? filterListData.length : 0;
    return { pagination: shouldShowDataTablePagination(len) };
}

/** Server-side total from API — enables pagination + paginationServer together. */
export function serverDataTablePagination(totalRows) {
    const show = shouldShowDataTablePagination(totalRows);
    return { pagination: show, paginationServer: show };
}

/** Any numeric total (e.g. filterRowsCount, totalNarrativeRows). */
export function countDataTablePagination(count) {
    return { pagination: shouldShowDataTablePagination(count) };
}

/**
 * When both `pagination` and `showPaginationBottom` must follow the same rule
 * (react-data-table-component).
 */
export function countDataTablePaginationWithBottom(count) {
    const show = shouldShowDataTablePagination(count);
    return { pagination: show, showPaginationBottom: show };
}
